<template>
  <v-container
    id="fichaPesquisaForm"
    fluid
    tag="section"
  >
    <base-material-card       
      color="primary"
      icon="mdi-clipboard-edit-outline"
      :title="$t('fichaPesquisa')">      
      <v-form>
        <v-main class="py-0" >
          <v-row >
            <v-col
              cols="5"
              md="3"
            >
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dataInicio"
                    class="purple-input"
                    label="Data inicio"
                    readonly
                    clearable
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="dataInicio"
                  class="purple-input"
                  no-title
                  scrollable
                  @input="menu1 = false"/>
              </v-menu>

            </v-col>
            <v-col
              cols="5"
              md="3"
            >
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dataFim"
                    class="purple-input"
                    label="Data fim"
                    readonly
                    clearable
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="dataFim"
                  class="purple-input"
                  no-title
                  scrollable
                  @input="menu2 = false"/>
              </v-menu>
            </v-col>
          </v-row>        
          <v-row >
            <v-col
              cols="5"
              md="3"
            >
            <v-combobox
                v-model="form.animal"
                :items="animalLista"
                label="Animal:"
                class="purple-input"
                item-text="titulo"
                clearable
                return-object
              ></v-combobox>
            </v-col> 
            <v-col
              cols="5"
              md="3"
            >
            <v-combobox
                v-model="form.tipoFicha"
                :items="tipoFichaLista"
                label="Tipo:"
                class="purple-input"
                item-text="nome"
                clearable
                return-object
              ></v-combobox>
            </v-col>
          </v-row>   
          <v-btn
          class="mr-4"
          color="default"
          @click="doCarregaForm">
          Busca
          </v-btn> 
          <v-btn
          class="mr-4"
          color="success"
          @click="doNovoCadastro">
          Novo
          </v-btn>             
      </v-main>
        <v-container class="py-0">
          <v-simple-table fixed-header >
            <template v-slot:default >
              <thead>
                <tr>
                  <th class="text-left">
                    Data
                  </th>
                  <th class="text-left">
                    Tipo Ficha
                  </th>       
                  <th class="text-left">
                    Descrição
                  </th>                                
                  <th class="text-left" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listaDados"
                  :key="item.id"
                >
                  <td>{{  doFormataData(item.data) }}</td>
                  <td>{{ item.tipoFicha.nome }}</td>
                  <td>{{ item.descricao }}</td>
                  <td>  <v-icon
                    small
                    class="mr-2"
                    @click="doEditaCadastro(item)"
                  >
                    mdi-pencil
                  </v-icon> </td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <fichaCadastroForm
            :exibedialog="dialog"
            :fichaObj="itemSelecionado"
            @update-dialog="updateDialog"
          />

        </v-container>
      </v-form>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import fichaCadastroForm from "../forms/FichaCadastroForm"
  import service from '../../../services/fichaservice'
  import servicetipoficha from '../../../services/tipofichaservice'
  import serviceanimal from '../../../services/animalservice'
  import utils from '../../../services/utils'
  
  export default {
    name: 'fichaPesquisaForm',
    components: {
      fichaCadastroForm,
    },
    directives: {
      mask,
    },
    watch: {
      dataInicio: function (val, oldVal) {
        this.form.dataInicio = utils.methods.gettanggal(val)
      },
      dataFim: function (val, oldVal) {
        this.form.dataFim = utils.methods.gettanggal(val)
      },
    },
    data: () => ({
      form: {
        animal: [],
        tipoFicha: [],
        dataInicio: '',
        dataFim: '',
        dataI: '',
        dataF: '',
      },
      listaDados: [{
        animal: {
          titulo : ""
        },
        tipoFicha: {
          nome : ""
        }
      }],
      itemSelecionado: {

      },
      dataInicio: null,
      dataFim: null,
      menu1: false, 
      menu2: false, 
      tipoFichaLista: [],      
      animalLista: [],      
      animalListaCadastro: [],      
      nomeErro: false,
      erros: [],
      dialog: false,
    }),
    mounted () {      
      this.doBuscaEntidades()
      this.doCarregaForm()
    },
    methods: {
      doCarregaForm () {   
        this.listaDados = []
        this.form.dataI = utils.methods.datastrtoJson(this.form.dataInicio)
        this.form.dataF = utils.methods.datastrtoJson(this.form.dataFim)
        service.listar(this.form).then(resposta => {
          this.listaDados = resposta.data.list
        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)
          } else {
            console.log('Erro listar(): ')
            console.log( e)                      
          }
        })
      },
      doValidate () {
        this.erros = []
     
        if (this.erros.length === 0) {
          return true
        }   
      },
      doEditaCadastro (item) {         
        this.itemSelecionado = item
        this.animalListaCadastro = []
        for (var k = 0; k < this.animalLista.length; k++) {
          this.animalListaCadastro.push(this.animalLista[k]);
        }
        this.dialog = true
      },
      doNovoCadastro () {
        this.animalListaCadastro = []
        for (var k = 0; k < this.animalLista.length; k++) {
          this.animalListaCadastro.push(this.animalLista[k]);
        }
        this.itemSelecionado = {}
        this.itemSelecionado.fichaAnimais = []
        this.dialog = true
      },
      updateDialog (dialog) {
        this.dialog = dialog
        this.doCarregaForm()
      },
      doFormataData(data){
        if(!data)
          return null
        return utils.methods.gettanggal(data)
      },      
      doBuscaEntidades () {
        servicetipoficha.listarAtivo().then(resposta => {

          this.tipoFichaLista = resposta.data.list;

        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)  

          } else {
            console.log('Erro listar(): ')
            console.log( e)                      
          }
        })
        serviceanimal.listarAtivo().then(resposta => {

          this.animalLista = resposta.data.list;

        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)  

          } else {
            console.log('Erro listar(): ')
            console.log( e)                      
          }
        })
      },      
    },
  }
</script>
